import auth from '@react-native-firebase/auth';
import { Logger, LogoutHelper } from '../../utils';

const signInWithCredential = async (tokens) => {
  try {
    Logger.leaveBreadcrumb('signInWithCredential');
    const credential = getCredentialFromTokens(tokens.providerId, tokens);
    return await auth().signInWithCredential(credential);
  } catch (err) {
    // similar to SocialAuth.onLogin
    Logger.debug(`[SocialAuth] signInWithCredential failed ${err}`);
    await LogoutHelper();
    throw err;
  }
};

function getCredentialFromTokens(providerId, tokens) {
  if (providerId === auth.GoogleAuthProvider.PROVIDER_ID) {
    return auth.GoogleAuthProvider.credential(tokens.idToken, tokens.accessToken);
  } else {
    throw new Error(`getCredentialFromTokens not implemented for provider ${providerId}`);
  }
}

export default signInWithCredential;
